import {
  Box,
  Button,
  Container,
  ExpandableSection,
  Grid,
  Header,
  Modal,
  Multiselect,
  SpaceBetween,
  TextContent,
  Textarea
} from '@cloudscape-design/components';
import { QandAResponses } from './qandaResponses';
import { useContext, useEffect, useRef, useState } from 'react';
import { DocumentContext } from '../../context/documentContext';
import { KnowledgeBaseModal } from './KnowledgeBaseModal';
import PopoverWrapper from './popoverWrapper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { QandASentence } from '../../models/interfaces';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { KBItemTypes } from '../../models/documentTableModel';
interface QandAModalProps {
  showQandQModal: boolean;
  handleCloseQnadAModal: () => void;
}

export const QandAModal = (props: QandAModalProps) => {
  const { showQandQModal, handleCloseQnadAModal } = props;
  const {
    getCurrentSentenceKB,
    selectedItemsKbResults,
    selectedItems,
    notesValue,
    setNotesValue,
    currentDoc,
    updateQASentence
  } = useContext(DocumentContext);

  const [localAnswerString, setLocalAnswerString] = useState<string>('');
  const [qaOpen, setQAOpen] = useState<boolean>(true);
  const [kbOpen, setKBOpen] = useState<boolean>(false);
  const [selectedTypes, setSelectedTypes] = useState<OptionDefinition[]>([]);

  const reactQuillRef = useRef<ReactQuill>(null);

  const getText = () => {
    if (reactQuillRef.current) {
      const editor = reactQuillRef.current.getEditor();
      console.log('editor text', editor.getText());
      return editor.getText();
    } else {
      return null;
    }
  };

  useEffect(() => {
    if (selectedItems[0]) {
      const current = selectedItems[0] as unknown as QandASentence;
      console.log('selected current item ', current.answer);
      setLocalAnswerString(current.htmlAnswer);
      setNotesValue(current.notes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);

  const handleSave = async () => {
    const textOnly = getText();
    updateQASentence(textOnly!, localAnswerString);
    handleCloseQnadAModal();
  };

  const handleAddToAnswer = (text: string) => {
    const tempString = localAnswerString + ' ' + text;
    setLocalAnswerString(tempString);
  };

  const kbQuantity = () => {
    if (selectedItems[0].kbSentences.length > 0) {
      return (
        selectedItems[0].kbSentences.length + selectedItemsKbResults.length
      );
    } else {
      return selectedItemsKbResults.length;
    }
  };

  const handleResearch = () => {
    if (selectedTypes.length > 0) {
      const typesToSend = selectedTypes.map((ele) => ele.label!);
      getCurrentSentenceKB('qaSentence', typesToSend);
    } else {
      getCurrentSentenceKB('qaSentence');
    }
  };

  return (
    <Modal
      header={
        <SpaceBetween size={'xs'}>
          <TextContent>
            <h4>Question</h4>
          </TextContent>
          <TextContent>{selectedItems[0].text}</TextContent>
        </SpaceBetween>
      }
      visible={showQandQModal}
      onDismiss={() => handleCloseQnadAModal()}
      size="max"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <PopoverWrapper
              popoverContent={'Save answer and notes'}
              sideToShow="LEFT"
              aboveBelow="TOP"
            >
              <Button
                variant="primary"
                onClick={() => handleSave()}
                disabled={currentDoc.status === 'Published'}
              >
                Save
              </Button>
            </PopoverWrapper>
          </SpaceBetween>
        </Box>
      }
    >
      <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
        <div style={{ height: '65vh', overflowY: 'scroll' }}>
          <Container>
            <SpaceBetween size={'s'}>
              <QandAResponses
                setLocalAnswerString={setLocalAnswerString}
                localAnswerString={localAnswerString}
                handleAddToAnswer={handleAddToAnswer}
                qaOpen={qaOpen}
                setQAOpen={setQAOpen}
              />
              {selectedItemsKbResults.length > 0 ||
              selectedItems[0].kbSentences.length > 0 ? (
                <ExpandableSection
                  variant="container"
                  headerText={`Knowledge Map - (${kbQuantity()})`}
                  expanded={kbOpen}
                  onChange={() => setKBOpen(!kbOpen)}
                >
                  <KnowledgeBaseModal
                    parentType="QandA"
                    filterType={[]}
                    setLocalAnswerString={setLocalAnswerString}
                    localAnswerString={localAnswerString}
                    handleAddToAnswer={handleAddToAnswer}
                  />
                </ExpandableSection>
              ) : null}
            </SpaceBetween>
          </Container>
        </div>
        <div style={{ height: '80vh', overflow: 'scroll' }}>
          <Container header={<Header>Build Answer</Header>}>
            <SpaceBetween size={'s'}>
              <div
                style={{
                  height: '50vh',
                  position: 'relative',
                  overflowY: 'hidden'
                }}
              >
                <ReactQuill
                  ref={reactQuillRef}
                  style={{
                    height: '100%',
                    overflowY: 'scroll',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%'
                  }}
                  theme="snow"
                  placeholder="Your selected answers go here. You can edit and format your response."
                  value={localAnswerString}
                  onChange={setLocalAnswerString}
                />
              </div>
              <Textarea
                value={notesValue}
                onChange={({ detail }) => setNotesValue(detail.value)}
                placeholder="You can type notes here! Not part of download."
              />
              <SpaceBetween size={'s'} direction="horizontal">
                <PopoverWrapper
                  sideToShow="RIGHT"
                  aboveBelow="TOP"
                  popoverContent={
                    'Research the Knowledgebase to find other relevant info'
                  }
                >
                  <Button
                    disabled={currentDoc.status === 'Published'}
                    onClick={() => {
                      handleResearch();
                      setQAOpen(false);
                    }}
                  >
                    Research
                  </Button>
                </PopoverWrapper>
                {currentDoc.status !== 'Published' && (
                  <Multiselect
                    selectedOptions={selectedTypes}
                    onChange={({ detail }) =>
                      setSelectedTypes([...detail.selectedOptions])
                    }
                    placeholder={
                      selectedTypes.length > 0
                        ? 'Use selected types'
                        : 'Select Types to research'
                    }
                    hideTokens
                    options={KBItemTypes}
                  ></Multiselect>
                )}
              </SpaceBetween>
            </SpaceBetween>
          </Container>
        </div>
      </Grid>
    </Modal>
  );
};
